import { toast } from "react-toastify";
import { i18n } from "../translate/i18n";
import { isString } from 'lodash';

const toastError = err => {
	const errorMsg = err.response?.data?.error;
	if (errorMsg) {
		if (errorMsg === "ERR_NO_MESSAGE_CONTENT_PROVIDED") {
			return;
		}
		if (errorMsg.startsWith("ERR_ASSISTANT_AI:")) {
			toast.error(errorMsg.replace("ERR_ASSISTANT_AI:", "").trim(), {
				toastId: errorMsg,
				autoClose: 4000,
			});
			return;
		}
		if (i18n.exists(`backendErrors.${errorMsg}`)) {
			toast.error(i18n.t(`backendErrors.${errorMsg}`), {
				toastId: errorMsg,
				autoClose: 2000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: false,
				draggable: true,
				progress: undefined,
				theme: "light",
			});
			return
		} else {
			toast.error(errorMsg, {
				toastId: errorMsg,
				autoClose: 2000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: false,
				draggable: true,
				progress: undefined,
				theme: "light",
			});
			return
		}
	} if (isString(err)) {
		toast.error(err);
		return
	} else if (err.code === "ECONNABORTED" || err.message?.includes("timeout")) {
		toast.error(i18n.t("backendErrors.ERR_ASSISTANT_TIMEOUT", {
			defaultValue: "La IA tardó demasiado. Intenta de nuevo o con un texto más corto.",
		}));
		return
	} else {
		toast.error("An error occurred!");
		return
	}
};

export default toastError;
